/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Created_AtInputs */

const en_admin_payments_created_at = /** @type {(inputs: Admin_Payments_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Admin_Payments_Created_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_created_at = /** @type {((inputs?: Admin_Payments_Created_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Created_AtInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_created_at(inputs)
});
export { admin_payments_created_at as "admin.payments.created_at" }